import users_api from "../../api/users"
import DateUtils from "../../utils/DateUtils";
import {useEffect, useState} from "react";
import {useNavigate, useLocation} from "react-router-dom";
import GenericDialog from "../../components/GenericDialog";
import GenericInput from "../../components/GenericInput";

import countries from "i18n-iso-countries";

import profile_logo from "../../assets/profile-user-icon.svg";
import TableDropdown from "../../components/TableDropdown";
import auth from "../../api/auth";



const Users = () => {

    const navigate = useNavigate()
    const location = useLocation();

    // Table Content
    const [itemsPerPage, setItemsPerPage] = useState(25);
    const [page, setPage] = useState(0)
    const [totalPages, setTotalPages] = useState(1)
    const [pageData, setPageData] = useState([])

    // Search fields
    const [name, setName] = useState("")
    const [countryCodes, setCountryCodes] = useState([]);

    const [searchQuery, setSearchQuery] = useState("");

    const [validityFilter, setValidityFilter] = useState(null)
    const [registrationFilter, setRegistrationFilter] = useState({ id: 1, name: "Latest" })
    const [subscriptionFilter, setSubscriptionFilter] = useState(null)
    const [accreditationFilter, setAccreditationFilter] = useState(null)
    const [countryFilter, setCountryFilter] = useState(null)
    const [loginFilter, setLoginFilter] = useState(null)

    const [showValidityFilter, setShowValidityFilter] = useState(false)
    const [showRegistrationFilter, setShowRegistrationFilter] = useState(false)
    const [showSubscriptionFilter, setShowSubscriptionFilter] = useState(false)
    const [showAccreditationFilter, setShowAccreditationFilter] = useState(false)
    const [showCountryFilter, setShowCountryFilter] = useState(false)
    const [showLoginFilter, setShowLoginFilter] = useState(false)

    const validityOptions = [{id: 1, name: "Validated"}, {id: 2, name: "Unvalidated"}]
    const registrationOptions = [{id: 1, name: "Latest"}, {id: 2, name: "Oldest"}]
    const subscriptionOptions = [{id: 1, name: "Gold"}, {id: 2, name: "Silver"}, {id: 3, name: "Bronze"}]
    const accreditationOptions = [{id: 1, name: "Verified"}, {id: 2, name: "Unverified"}]
    const loginOptions = [{id: 1, name: "Latest"}, {id: 2, name: "Oldest"}]

    const [selectedFilters, setSelectedFilters] = useState([
        {id: 1, type: "validity", value:""},
        {id: 2, type: "registration", value:"Latest"},
        {id: 3, type: "subscription", value:""},
        {id: 4, type: "accreditation", value:""},
        {id: 5, type: "country", value:""},
        {id: 6, type: "login", value:""}
    ])

    // Error Dialog
    const [dialogTitle, setDialogTitle] = useState("")
    const [dialogText, setDialogText] = useState("")
    const buttons = [{"text":"OK", "id": "1"}];

    useEffect(() => {
        auth.hasSession().then((session) => {
            if (!session) window.location.assign("/logout");
        });
    }, [])

    useEffect(() => {
        const params = new URLSearchParams(location.search);

        // search + page
        const search = params.get("q") || "";
        const pageParam = parseInt(params.get("p"), 10);
        const ipp = parseInt(params.get("ipp"), 10);

        setName(search);
        setSearchQuery(search);
        if (!isNaN(pageParam)) setPage(pageParam);
        if (!isNaN(ipp)) setItemsPerPage(ipp);

        // filters
        const vId = params.get("v") ? Number(params.get("v")) : null;
        const rId = params.get("r") ? Number(params.get("r")) : null;
        const sId = params.get("s") ? Number(params.get("s")) : null;
        const aId = params.get("a") ? Number(params.get("a")) : null;
        const cId = params.get("c") || null;
        const lId = params.get("l") ? Number(params.get("l")) : null;

        if (vId) setValidityFilter(validityOptions.find(o => o.id === vId) || null);
        if (rId && !lId) setRegistrationFilter(registrationOptions.find(o => o.id === rId) || null);
        if (sId) setSubscriptionFilter(subscriptionOptions.find(o => o.id === sId) || null);
        if (aId) setAccreditationFilter(accreditationOptions.find(o => o.id === aId) || null);
        if (cId) setCountryFilter({ id: cId });
        if (lId) setLoginFilter(loginOptions.find(o => o.id === lId) || null);
        if (lId) setRegistrationFilter(null);

        // for filter boxes
        setSelectedFilters([
            { id: 1, type: "validity", value: vId ? validityOptions.find(o => o.id === vId)?.name || "" : "" },
            { id: 2, type: "registration", value: lId ? "" : (rId ? registrationOptions.find(o => o.id === rId)?.name || "" : registrationFilter.name || "")},
            { id: 3, type: "subscription", value: sId ? subscriptionOptions.find(o => o.id === sId)?.name || "" : "" },
            { id: 4, type: "accreditation", value: aId ? accreditationOptions.find(o => o.id === aId)?.name || "" : "" },
            { id: 5, type: "country", value: cId || "" },
            { id: 6, type: "login", value: lId ? loginOptions.find(o => o.id === lId)?.name || "" : "" }
        ]);
    }, []);

    const updateUrlParams = (updates) => {
        const params = new URLSearchParams(location.search);

        Object.entries(updates).forEach(([key, value]) => {
            if (value === null || value === "" || value === undefined) {
                params.delete(key);
            } else {
                params.set(key, value.toString());
            }
        });

        navigate({ search: params.toString() });
    };

    useEffect(() => {
        GetUsers()
        GetCountries()
    }, []);

    useEffect(() => {
        GetUsers()
    }, [searchQuery, validityFilter, registrationFilter, subscriptionFilter, accreditationFilter, countryFilter, loginFilter, itemsPerPage, page]);

    const GetUsers = () => {
        let body = {}
        if (searchQuery && searchQuery) body["global"] = searchQuery
        if (validityFilter?.id) body["validity"] = validityFilter
        if (registrationFilter?.id) body["registration"] = registrationFilter
        if (subscriptionFilter?.id) body["subscriptions"] = subscriptionFilter
        if (accreditationFilter?.id) body["accreditation"] = accreditationFilter
        if (countryFilter?.id) body["country"] = countryFilter
        if (loginFilter?.id) body["login"] = loginFilter
        let response = users_api.GetUsers(itemsPerPage, page * itemsPerPage, body)
        response.then(
            response => {
                // Page items
                let data = response.data.users
                setPageData(data)

                // Calculate total pages:
                let pages_needed = Math.ceil(response.data.total_count / itemsPerPage)
                if (pages_needed < 1) pages_needed = 1
                setTotalPages(pages_needed)
            }
        ).catch((err) => {
            setDialogTitle("Fetching Error")
            setDialogText("There was an error fetching users. Please try again")
        })
    }

    const GetCountries = () => {
        let items = [];
        countries.registerLocale(require("i18n-iso-countries/langs/en.json"));
        for (const [key, value] of Object.entries(countries.getNames("en", {select: "official"}))){
            let item = {};
            item.id = key;
            item.name = value;
            items.push(item);
        }
        setCountryCodes(items);
    }

    const getCountry = (key) => {
        countries.registerLocale(require("i18n-iso-countries/langs/en.json"));
        for (const [item_key, value] of Object.entries(countries.getNames("en", {select: "official"}))){
            if (item_key === key) return value;
        }
        return key;
    }

    const handleNumberClick = (ev) => {
        if (!page && page !== 0) return;
        if (!ev.target.id && ev.target.id !== 0) return;
        const pg = parseInt(ev.target.id);

        setPage(pg);

        const params = new URLSearchParams(location.search);
        params.set("p", pg.toString());

        navigate({ search: params.toString() });
    }

    const handleNextPageClick = () => {
        if (!page && page !== 0) return;
        if (page + 1 < totalPages) {
            const next = page + 1;
            setPage(next);

            const params = new URLSearchParams(location.search);
            params.set("p", next.toString());
            navigate({ search: params.toString() });
        }
    }

    const handlePreviousPageClick = () => {
        if (!page && page !== 0) return;
        if (page > 0) {
            const prev = page - 1;
            setPage(prev);

            const params = new URLSearchParams(location.search);
            params.set("p", prev.toString());
            navigate({ search: params.toString() });
        }
    }

    const handleErrorDialogResult = (res) => {
        if(!res) return;
        setDialogText("")
        setDialogTitle("")
    }

    const handleDropdown = (title) => {
        switch (title) {
            case "validate":
                setShowValidityFilter(!showValidityFilter)
                break;
            case "registered_date":
                setShowRegistrationFilter(!showRegistrationFilter)
                break;
            case "subscription":
                setShowSubscriptionFilter(!showSubscriptionFilter)
                break;
            case "accreditation":
                setShowAccreditationFilter(!showAccreditationFilter)
                break;
            case "country":
                setShowCountryFilter(!showCountryFilter)
                break;
            case "login":
                setShowLoginFilter(!showLoginFilter)
                break;
        }
    }

    const addSelectedFilters = (idx, value) => {
        let _temp = [...selectedFilters]
        _temp[idx].value = value
        setSelectedFilters(_temp)
    }

    const addFilter = (obj, title) => {
        if (!obj || !title) return;
        switch (title) {
            case "validity":
                setValidityFilter(obj)
                setShowValidityFilter(!showValidityFilter)
                addSelectedFilters(0, obj.name)
                updateUrlParams({ v: obj.id, p: 0 });
                break;
            case "registered_date":
                setLoginFilter(null)
                addSelectedFilters(5, "")
                setRegistrationFilter(obj)
                setShowRegistrationFilter(!showRegistrationFilter)
                addSelectedFilters(1, obj.name)
                updateUrlParams({ r: obj.id, l: null, p: 0 });
                break;
            case "subscription":
                setSubscriptionFilter(obj)
                setShowSubscriptionFilter(!showSubscriptionFilter)
                addSelectedFilters(2, obj.name)
                updateUrlParams({ s: obj.id, p: 0 });
                break;
            case "accreditation":
                setAccreditationFilter(obj)
                setShowAccreditationFilter(!showAccreditationFilter)
                addSelectedFilters(3, obj.name)
                updateUrlParams({ a: obj.id, p: 0 });
                break;
            case "country":
                setCountryFilter(obj)
                setShowCountryFilter(!showCountryFilter)
                addSelectedFilters(4, obj.name)
                updateUrlParams({ c: obj.id, p: 0 });
                break;
            case "login":
                setRegistrationFilter(null)
                addSelectedFilters(1, "")
                setLoginFilter(obj)
                setShowLoginFilter(!showLoginFilter)
                addSelectedFilters(5, obj.name)
                updateUrlParams({ l: obj.id, r: null, p: 0 });
                break;
        }

    }

    const removeFilter = (id) => {
        if (!id) return;
        let _temp = [...selectedFilters]
        _temp[id - 1].value = ""
        setSelectedFilters(_temp)
        switch (id) {
            case 1:
                setValidityFilter(null)
                setPage(0)
                updateUrlParams({ v: null, p: 0 });
                break;
            case 2:
                setRegistrationFilter(null)
                setPage(0)
                updateUrlParams({ r: null, p: 0 });
                break;
            case 3:
                setSubscriptionFilter(null)
                setPage(0)
                updateUrlParams({ s: null, p: 0 });
                break;
            case 4:
                setAccreditationFilter(null)
                setPage(0)
                updateUrlParams({ a: null, p: 0 });
                break;
            case 5:
                setCountryFilter(null)
                setPage(0)
                updateUrlParams({ c: null, p: 0 });
                break;
            case 6:
                setLoginFilter(null)
                setPage(0)
                updateUrlParams({ l: null, p: 0 });
                break;
        }
    }

    const applySearch = () => {
        setSearchQuery(name);
        setPage(0);

        updateUrlParams({q: name, p: 0});
    };

    return (
        <div className="page-container">
            <div className="page-title">
                Users
            </div>
            <div className="items-per-page-container">
                <label>Items per page: </label>
                <select
                    value={itemsPerPage}
                    onChange={(e) => {
                        setItemsPerPage(parseInt(e.target.value));
                        setPage(0);
                        updateUrlParams({ ipp: e.target.value, p: 0 });
                    }}
                >
                    <option value={25}>25</option>
                    <option value={50}>50</option>
                    <option value={100}>100</option>
                    <option value={200}>200</option>
                </select>
            </div>
            <div className="search-users-container">
                <div className="user-search-field-container">
                    <form onSubmit={(e) => {
                            e.preventDefault();
                            applySearch();
                        }}>
                        <GenericInput label="Global search" value={name} updateValue={setName} />

                        <div className="search-actions-row">
                            <div className="search-button link" onClick={() => applySearch()}>
                                Search
                            </div>
                            <div className="reset-button link" onClick={() => { setName(""); setSearchQuery(""); }}>
                                Reset
                            </div>
                        </div>

                        {/* hidden submit button so Enter works */}
                        <button type="submit" style={{ display: 'none' }}></button>
                    </form>
                </div>
            </div>

            <div className="user-search-filters-container">
                {selectedFilters && selectedFilters.map((filter, idx) => {
                    return(
                        <div className={filter.value !== "" ? "user-selected-filter-container" : "user-selected-filter-container hide"}>
                            <div className="user-selected-filter-cross-container link" onClick={() => removeFilter(filter.id)}>
                                x
                            </div>
                            <div className="user-selected-filter-text-container">{filter.value}</div>
                        </div>
                    )
                })}
            </div>

            <div className="table-container">
                <div className="table-row">
                    <div className="table-column wide heading">User Details</div>
                    <div className="table-column heading">
                        <div className="table-dropdown-button-container">
                            <div className="table-dropdown-button link" onClick={() => handleDropdown("validate")}>{">"}</div>
                        </div>
                        {showValidityFilter ?
                            <TableDropdown options={validityOptions} dropdown={"validity"} update={addFilter.bind(this)}/>
                            :null}
                        Email Validated
                    </div>
                    <div className="table-column heading">
                        <div className="table-dropdown-button-container">
                            <div className="table-dropdown-button link" onClick={() => handleDropdown("registered_date")}>{">"}</div>
                        </div>
                        {showRegistrationFilter ?
                            <TableDropdown options={registrationOptions} dropdown={"registered_date"} update={addFilter.bind(this)}/>
                            :null}
                        Registered date
                    </div>

                    <div className="table-column heading">
                        <div className="table-dropdown-button-container">
                            <div className="table-dropdown-button link" onClick={() => handleDropdown("subscription")}>{">"}</div>
                        </div>
                        {showSubscriptionFilter ?
                            <TableDropdown options={subscriptionOptions} dropdown={"subscription"} update={addFilter.bind(this)}/>
                            :null}
                        Subscription Level
                    </div>
                    <div className="table-column heading">
                        <div className="table-dropdown-button-container">
                            <div className="table-dropdown-button link" onClick={() => handleDropdown("accreditation")}>{">"}</div>
                        </div>
                        {showAccreditationFilter ?
                            <TableDropdown options={accreditationOptions} dropdown={"accreditation"} update={addFilter.bind(this)}/>
                            :null}
                        Accredited (if applicable)
                    </div>
                    <div className="table-column heading">
                        <div className="table-dropdown-button-container">
                            <div className="table-dropdown-button link" onClick={() => handleDropdown("country")}>{">"}</div>
                        </div>
                        {showCountryFilter ?
                            <TableDropdown options={countryCodes} dropdown={"country"} update={addFilter.bind(this)}/>
                            :null}
                        Country
                    </div>
                    <div className="table-column heading narrow">
                        <div className="table-dropdown-button-container">
                            <div className="table-dropdown-button link" onClick={() => handleDropdown("login")}>{">"}</div>
                        </div>
                        {showLoginFilter ?
                            <TableDropdown options={loginOptions} dropdown={"login"} update={addFilter.bind(this)}/>
                            :null}
                        Last log in Date
                    </div>
                </div>
                {pageData && pageData.map((item, idx) => {
                    return (
                        <div className="table-row link" onClick={() => navigate(`/users/${item.email}${location.search}`)}>
                            <div className="table-column wide">
                                <div className="column-container">
                                    <div className="users-profile-picture-container">
                                        <div className={item.profile_image && item.profile_image
                                            ? "profile-image-circle"
                                            : "profile-image-circle default"}>
                                            <img src={item.profile_image && item.profile_image
                                                ? item.profile_image
                                                : profile_logo} alt="Profile"/>
                                        </div>
                                    </div>
                                    <div className="users-info-container">
                                        <div className="user-name">
                                            {item.fullname}
                                        </div>
                                        <div className="email">
                                        {item.email}
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="table-column">
                                {item.email_validated === 1 ?
                                    <div className="verification-container verified">Validated</div>
                                :
                                    <div className="verification-container">Not Validated</div>
                                }
                            </div>
                            <div className="table-column">
                                <div className="validated-container">
                                    {item.registered_date && DateUtils.display_date_short(item.registered_date)}
                                </div>
                            </div>
                            <div className="table-column">
                                <div className={item.subscription_level && item.subscription_level
                                    ? "subscription-container " + item.subscription_level.toString().toLowerCase()
                                    : "subscription-container"}>
                                    {item.subscription_level && item.subscription_level}
                                </div>
                            </div>
                            <div className="table-column">
                                {item.subscription_level === "Bronze" ? (
                                    <div className="verification-container bronze">
                                        N/a
                                    </div>
                                ) : item.verified === 1 ? (
                                    <div className="verification-container verified">
                                        Verified
                                    </div>
                                ) : (
                                    <div className="verification-container">
                                        {item.accred_declined === 1 ? "Declined" : "Not Verified"}
                                    </div>
                                )}
                            </div>
                            <div className="table-column">
                                <div className="country-container">
                                    {getCountry(item.country)}
                                </div>
                            </div>
                            <div className="table-column narrow last">
                                <div className="country-container">
                                    {item.last_seen && DateUtils.display_date_short(item.last_seen)}
                                </div>
                            </div>
                        </div>
                    )
                })}
            </div>
            <div className="table-navigation-button-container">
                <div className="table-left button link" onClick={handlePreviousPageClick}>{"<"}</div>
                <div className="table-pages">
                    {/* Always show first page */}
                    <div className={page === 0 ? "page active link" : "page link"}
                        onClick={handleNumberClick}
                        id="0"
                    >
                        1
                    </div>

                    {/* Calculate middle page range */}
                    {totalPages > 2 && (() => {
                        const middlePages = [];
                        const start = Math.max(1, page - 2);
                        const end = Math.min(totalPages - 2, page + 2);

                        if (start > 1) middlePages.push(<div key="dots-left" className="page dots">...</div>);

                        for (let i = start; i <= end; i++) {
                            middlePages.push(
                                <div key={i} className={page === i ? "page active link" : "page link"}
                                    onClick={handleNumberClick}
                                    id={i.toString()}
                                >
                                    {i + 1}
                                </div>
                            );
                        }

                        if (end < totalPages - 2) middlePages.push(<div key="dots-right" className="page dots">...</div>);

                        return middlePages;
                    })()}

                    {/* Always show last page if more than 1 page */}
                    {totalPages > 1 && (
                        <div className={page === totalPages - 1 ? "page active link" : "page link"}
                            onClick={handleNumberClick}
                            id={(totalPages - 1).toString()}
                        >
                            {totalPages}
                        </div>
                    )}
                </div>
                <div className="table-right button link" onClick={handleNextPageClick}>{">"}</div>
            </div>

            {dialogText && dialogText ? <GenericDialog title={dialogTitle} text={dialogText} buttons={buttons}
                                                       result={handleErrorDialogResult.bind(this)}/> : null}
        </div>
    )


}

export default Users